"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var order_type_1 = require("../order-type");
/**
 * Base class for AbstractColumnTreeElementDto and RowCategoryDto, contains common properties for report element.
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var AbstractTreeElementDto = /** @class */ (function () {
    function AbstractTreeElementDto() {
        /**
         * Sort Type of Measure wrapper
         */
        this.orderType = order_type_1.OrderType.NONE;
        /**
         * Applied filter for report element.
         */
        this.filterTreeDto = null;
    }
    return AbstractTreeElementDto;
}());
exports.AbstractTreeElementDto = AbstractTreeElementDto;
//# sourceMappingURL=abstract-tree-element-dto.js.map